import { labelOnly } from "../label-only";
import type { ToolActivity } from "../tool-activity";
import { toolInput } from "../tool-input";

export function describeReportFinding(
  record: Record<string, unknown>,
): ToolActivity {
  const title = toolInput.str(record.title);
  const severity = toolInput.str(record.severity);
  if (!title) {
    return labelOnly("Reported a finding");
  }
  const prefix = severity ? `${severity}: ` : "";
  return labelOnly(
    `Reported a finding, ${prefix}${toolInput.truncate(title, 60)}`,
  );
}
